export default function getLogoUrl(filename) {
  return `/api/logo/${filename}/`;
}
